import React from "react";

// Lightweight inline SVG icons (stroke = currentColor).
const P = { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };

const ICONS = {
  node: (
    <>
      <circle cx="12" cy="12" r="3" />
      <circle cx="5" cy="6" r="2" /><circle cx="19" cy="6" r="2" />
      <circle cx="5" cy="18" r="2" /><circle cx="19" cy="18" r="2" />
      <path d="M7 7l3 3M17 7l-3 3M7 17l3-3M17 17l-3-3" />
    </>
  ),
  link: (<><path d="M9 15l6-6" /><path d="M11 6l1-1a3.5 3.5 0 015 5l-2 2" /><path d="M13 18l-1 1a3.5 3.5 0 01-5-5l2-2" /></>),
  users: (<><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3 3-5 6-5s6 2 6 5" /><circle cx="17.5" cy="9" r="2.2" /><path d="M16 20c0-2.3 1.6-4 4-4.3" /></>),
  coins: (<><ellipse cx="9" cy="7" rx="6" ry="3" /><path d="M3 7v5c0 1.7 2.7 3 6 3s6-1.3 6-3V7" /><path d="M9 15v3c0 1.7 2.7 3 6 3s6-1.3 6-3v-5" /><path d="M15 10c2.8.2 6 1.3 6 3" /></>),
  gauge: (<><path d="M4 18a8 8 0 1116 0" /><path d="M12 18l4-5" /><circle cx="12" cy="18" r="1.4" fill="currentColor" stroke="none" /></>),
  activity: (<><path d="M3 12h4l3 8 4-16 3 8h4" /></>),
  gift: (<><rect x="3" y="9" width="18" height="12" rx="1.5" /><path d="M3 13h18M12 9v12" /><path d="M12 9S10 3 7.5 4.5 9 9 12 9zM12 9s2-6 4.5-4.5S15 9 12 9z" /></>),
  rocket: (<><path d="M5 15c-1 1-1.5 4-1.5 4s3-.5 4-1.5" /><path d="M9 15l-3-3c1-5 5-9 11-9 0 6-4 10-9 11z" /><circle cx="14.5" cy="9.5" r="1.5" /></>),
  shield: (<><path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z" /><path d="M9 12l2 2 4-4" /></>),
  layers: (<><path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5" /></>),
  spark: (<><path d="M12 3v4M12 17v4M3 12h4M17 12h4" /><path d="M12 8l1.5 2.5L16 12l-2.5 1.5L12 16l-1.5-2.5L8 12l2.5-1.5z" fill="currentColor" stroke="none" /></>),
  fraction: (<><circle cx="12" cy="12" r="9" /><path d="M12 3a9 9 0 010 18z" fill="currentColor" stroke="none" opacity="0.35" /><path d="M12 3v18" /></>),
};

export default function Icon({ name, size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...P}>
      {ICONS[name] || ICONS.spark}
    </svg>
  );
}
